import React from 'react';
import Footer from '../../components/layout/Footer';

import HeaderMeta from 'components/headerMeta/HeaderMeta';
import { buildPageBreadcrumb } from 'untils/jsonLdSchemas';
import '../../assets/style/itemStyle/common.scss';

const CreditPolicy = () => {
  return (
    <>
      <HeaderMeta
        type="creditPolicy"
        jsonLd={[buildPageBreadcrumb('Airacer Credits Policy', '/creditPolicy')]}
      />
      <div className="privacy-policy-content">
        <p style={{ textAlign: 'center' }}>
          <h1 style={{ textDecoration: 'underline' }}>AIRACER CREDITS POLICY</h1>
        </p>

        <h2 id="1-overview">1. Overview</h2>
        <p>
          This Airacer Credits Policy governs service credits issued by Airacer to customers for use
          toward eligible future Airacer services (“Airacer Credits”).
        </p>
        <p>
          Airacer Credits may be issued in connection with service adjustments, customer
          accommodations, promotions, goodwill gestures, service recovery, or other non-refund
          circumstances determined by Airacer.
        </p>
        <p>
          This Policy does not apply where a Customer is otherwise entitled to receive a cash refund
          and elects to convert that refund into credit. Any such Refund Credit, if offered, will be
          subject to separate written terms.
        </p>
        <p>
          Airacer Credits are intended solely for use toward eligible Airacer services and are not
          offered as a general-purpose payment product.
        </p>
        <p>
          Unless otherwise stated in writing, all Airacer Credits are subject to this Policy together
          with any specific terms communicated when the Credit is issued.
        </p>

        <h2 id="2-types-of-airacer-credits">2. Types of Airacer Credits</h2>
        <p>Airacer may issue different types of Airacer Credits, including:</p>
        <ul>
          <li>Service Credits</li>
          <li>Promotional Credits</li>
          <li>Goodwill Credits</li>
          <li>Service Recovery Credits</li>
          <li>Complimentary Credits</li>
          <li>other non-refund service-related Credits</li>
        </ul>
        <p>
          Different Credits may be subject to different validity periods, usage restrictions,
          eligible services, booking requirements, or other conditions.
        </p>
        <p>
          Any specific terms applicable to a particular Credit will be communicated to the Customer
          when the Credit is issued.
        </p>

        <h2 id="3-nature-of-airacer-credits">3. Nature of Airacer Credits</h2>
        <p>
          Airacer Credits are service credits that may be applied toward eligible future charter
          bookings or other eligible services arranged directly through Airacer.
        </p>
        <p>Airacer Credits:</p>
        <ul>
          <li>are not available for purchase by Customers;</li>
          <li>cannot be independently funded, loaded, or topped up by Customers;</li>
          <li>do not earn interest, investment returns, or other financial returns;</li>
          <li>
            cannot be withdrawn through a bank account, ATM, payment card, payment network, or similar
            mechanism;
          </li>
          <li>cannot be used to transfer funds or value between Customers;</li>
          <li>cannot be used to purchase goods or services directly from third-party merchants;</li>
          <li>are not redeemable for cash, except where required by applicable law; and</li>
          <li>
            may only be used in accordance with this Policy and the specific terms applicable to the
            Credit.
          </li>
        </ul>
        <p>
          Airacer Credits are intended solely as credits toward eligible Airacer services and are not
          designed to function as a deposit account, payment account, investment product, wallet, or
          general-purpose payment instrument.
        </p>

        <h2 id="4-issuance">4. Issuance</h2>
        <p>
          Airacer Credits may be issued by Airacer at its discretion in connection with service
          adjustments, customer resolutions, promotions, goodwill gestures, service recovery, or
          other non-refund arrangements.
        </p>
        <p>
          Customers may not purchase Airacer Credits or add funds to an existing Airacer Credit
          balance.
        </p>
        <p>
          Airacer Credits may not be created by depositing, pre-funding, or transferring money to
          Airacer for future use.
        </p>
        <p>
          The amount, permitted use, validity period, eligible services, and other conditions
          applicable to a Credit may vary depending on the circumstances under which it was issued.
        </p>
        <p>
          Issuance of a Credit in one instance does not create an obligation for Airacer to issue the
          same or similar Credit in the future.
        </p>

        <h2 id="5-refunds-and-customer-funds-excluded">5. Refunds and Customer Funds Excluded</h2>
        <p>This Policy does not apply to:</p>
        <ul>
          <li>cash refunds otherwise owed to a Customer;</li>
          <li>funds prepaid or deposited by a Customer for future services;</li>
          <li>unused Customer funds held in connection with a specific booking;</li>
          <li>Customer-funded account balances;</li>
          <li>amounts transferred to Airacer for safekeeping or future spending; or</li>
          <li>
            any other Customer funds that are not independently issued by Airacer as a non-refund
            service Credit.
          </li>
        </ul>
        <p>
          Airacer will not characterize Customer funds or an otherwise payable cash refund as a
          Promotional, Goodwill, Service Recovery, or Complimentary Credit solely for purposes of
          applying this Policy.
        </p>
        <p>
          Any arrangement under which a Customer voluntarily elects to receive credit instead of an
          otherwise payable cash refund will be governed by separate written terms.
        </p>

        <h2 id="6-eligible-use">6. Eligible Use</h2>
        <p>
          Airacer Credits may only be applied toward eligible charter bookings or other eligible
          services arranged directly through Airacer.
        </p>
        <p>Use of Airacer Credits remains subject to:</p>
        <ul>
          <li>aircraft availability;</li>
          <li>operator approval;</li>
          <li>applicable booking terms;</li>
          <li>payment deadlines;</li>
          <li>any applicable minimum booking amount; and</li>
          <li>any restrictions communicated when the Credit was issued.</li>
        </ul>
        <p>
          Airacer Credits do not guarantee aircraft availability, future pricing, or confirmation of
          any booking.
        </p>
        <p>
          If the total cost of an eligible booking exceeds the available Credit balance, the Customer
          must separately pay the remaining amount using a payment method accepted by Airacer.
        </p>

        <h2 id="7-excluded-bookings-and-charges">7. Excluded Bookings and Charges</h2>
        <p>Airacer Credits may not be used toward any Empty Leg flight.</p>
        <p>
          Unless otherwise expressly stated in writing, Airacer Credits may also not be applied
          toward third-party or pass-through charges, including:
        </p>
        <ul>
          <li>taxes and Federal Excise Tax;</li>
          <li>international taxes;</li>
          <li>airport or FBO charges;</li>
          <li>ground handling;</li>
          <li>de-icing;</li>
          <li>permit fees;</li>
          <li>pet or cleaning fees;</li>
          <li>catering;</li>
          <li>payment processing fees;</li>
          <li>wire fees; and</li>
          <li>other third-party costs.</li>
        </ul>
        <p>
          Additional restrictions may apply to a specific Credit if disclosed when the Credit is
          issued.
        </p>

        <h2 id="8-partial-use-and-remaining-balance">8. Partial Use and Remaining Balance</h2>
        <p>
          If an eligible booking uses only part of an available Airacer Credit, the remaining balance
          may continue to be available for future eligible use, subject to the applicable terms and
          any lawful validity period.
        </p>
        <p>
          If multiple Credits are available, Airacer may determine the order in which Credits are
          applied, subject to any specific terms applicable to those Credits.
        </p>

        <h2 id="9-non-transferability">9. Non-Transferability</h2>
        <p>
          Unless expressly approved by Airacer in writing and permitted by applicable law, Airacer
          Credits are issued to the specific Customer or account identified at issuance.
        </p>
        <p>Airacer Credits may not be:</p>
        <ul>
          <li>sold;</li>
          <li>assigned;</li>
          <li>traded;</li>
          <li>exchanged;</li>
          <li>transferred for value;</li>
          <li>gifted;</li>
          <li>combined with another Customer’s Credit balance; or</li>
          <li>used to transfer funds or value from one Customer to another.</li>
        </ul>
        <p>
          Airacer may require verification of the Customer or account before allowing Credits to be
          used.
        </p>

        <h2 id="10-validity-and-expiration">10. Validity and Expiration</h2>
        <p>
          Any applicable validity period or expiration date will be communicated when the Airacer
          Credit is issued and will be subject to applicable law.
        </p>
        <p>
          Unless otherwise stated in writing, where a lawful expiration date applies, the Customer
          must confirm an eligible booking before that expiration date. The flight itself may take
          place after that date.
        </p>
        <p>
          Airacer will not impose an expiration period where doing so would be prohibited by
          applicable law.
        </p>

        <h2 id="11-customer-cancellation">11. Customer Cancellation</h2>
        <p>
          If a booking made in whole or in part using Airacer Credits is canceled by the Customer,
          treatment of the Credits will be governed by the cancellation terms applicable to that
          booking.
        </p>
        <p>
          Credits applied toward valid cancellation charges, non-refundable amounts, operator
          charges, or other amounts properly due under the applicable booking terms may be treated
          as used and may not be reinstated.
        </p>
        <p>
          Any refundable or unused portion may be reinstated as Airacer Credits in accordance with
          the applicable booking terms.
        </p>

        <h2 id="12-operator-cancellation-and-credit-reinstatement">
          12. Operator Cancellation and Credit Reinstatement
        </h2>
        <p>
          If a booking paid in whole or in part using Airacer Credits is canceled, withdrawn, or
          materially changed due to operator or operational reasons, any refundable amount
          attributable to the portion originally paid using Airacer Credits may be reinstated as
          Airacer Credits, subject to applicable law and the applicable booking terms.
        </p>
        <p>
          Amounts originally paid in cash or by another payment method will be handled in accordance
          with the applicable booking and refund terms.
        </p>
        <p>
          Airacer is not required to reinstate Credits applied toward valid non-refundable Airacer
          fees, third-party charges, cancellation charges, or other non-recoverable costs.
        </p>

        <h2 id="13-cash-redemption">13. Cash Redemption</h2>
        <p>
          Except where required by applicable law, Airacer Credits covered by this Policy are not
          redeemable for cash.
        </p>
        <p>
          Promotional Credits, Service Credits, Goodwill Credits, Service Recovery Credits,
          Complimentary Credits, or other similar non-refund Credits have no cash redemption value
          except where required by applicable law.
        </p>
        <p>
          This Section does not apply to Refund Credits, Customer deposits, or any situation in which
          a Customer is otherwise entitled to receive a cash refund.
        </p>

        <h2 id="14-promotional-and-special-credits">14. Promotional and Special Credits</h2>
        <p>
          Promotional, complimentary, or special-purpose Credits may be subject to additional terms,
          including:
        </p>
        <ul>
          <li>eligibility requirements;</li>
          <li>expiration dates;</li>
          <li>minimum booking values;</li>
          <li>eligible routes or aircraft categories;</li>
          <li>one-time-use restrictions;</li>
          <li>blackout dates;</li>
          <li>restrictions on combination with other Credits or offers; and</li>
          <li>other specific conditions.</li>
        </ul>
        <p>
          Any specific terms communicated when a promotional or special Credit is issued will apply
          in addition to this Policy and applicable law.
        </p>

        <h2 id="15-misuse-fraud-and-errors">15. Misuse, Fraud, and Errors</h2>
        <p>
          Airacer may suspend, reverse, cancel, or refuse the use of Credits where Airacer
          reasonably determines that the Credits were:
        </p>
        <ul>
          <li>issued in error;</li>
          <li>obtained through fraud or misrepresentation;</li>
          <li>duplicated;</li>
          <li>improperly transferred;</li>
          <li>used in violation of this Policy; or</li>
          <li>associated with a disputed, reversed, fraudulent, or otherwise invalid payment.</li>
        </ul>
        <p>
          Airacer may correct administrative, technical, or accounting errors affecting a Credit
          balance.
        </p>
        <p>
          This provision does not permit Airacer to eliminate or reduce valid Credit rights contrary
          to applicable law.
        </p>

        <h2 id="16-no-guarantee-of-future-pricing">16. No Guarantee of Future Pricing</h2>
        <p>
          Airacer Credits do not lock in or guarantee the price of any future charter flight or
          service.
        </p>
        <p>
          Future bookings remain subject to then-current aircraft availability, operator pricing,
          market conditions, taxes, fees, and other applicable charges.
        </p>
        <p>The Customer is responsible for any amount exceeding the available Credit balance.</p>

        <h2 id="17-no-periodic-holding-fees">17. No Periodic Holding Fees</h2>
        <p>
          Airacer does not charge dormancy, maintenance, administrative, inactivity, service, or
          similar periodic fees merely for holding an unused Airacer Credit.
        </p>
        <p>
          This does not prevent Airacer from charging separately disclosed fees associated with an
          actual charter booking or service where permitted by applicable law.
        </p>

        <h2 id="18-no-waiver-and-policy-changes">18. No Waiver and Policy Changes</h2>
        <p>
          Any exception, extension, reinstatement, or other accommodation provided by Airacer in a
          particular case applies only to that case and does not create an obligation to provide the
          same treatment in the future.
        </p>
        <p>Airacer may update this Policy from time to time.</p>
        <p>
          Any changes will apply prospectively and will not materially reduce or eliminate rights
          attached to Credits already issued, except where permitted or required by applicable law.
        </p>

        <h2 id="19-order-of-precedence">19. Order of Precedence</h2>
        <p>
          If specific written terms applicable to a particular Airacer Credit conflict with this
          general Policy, the specific written terms communicated when that Credit was issued will
          control, subject to applicable law.
        </p>
        <p>
          When Airacer Credits are applied toward a charter booking, the applicable Booking
          Confirmation, Charter Agreement, cancellation terms, refund terms, and other
          booking-specific written terms will also apply.
        </p>
        <p>
          Nothing in this Policy limits any right that cannot lawfully be waived or restricted under
          applicable law.
        </p>
      </div>
      <Footer />
    </>
  );
};

export default CreditPolicy;
